import React, { Component } from 'react'
import LicenseAdd from "../../containers/GeneratedLicenses/GeneratedLicenseAdd";
import LicenseList from '../../containers/GeneratedLicenses/GeneratedLicenseList'




class GeneratedLicenseManagement extends Component {
    constructor(props) {
        super(props);
    }

    componentWillMount() {
        this.props.getAllLicenses();
    }

    render() {
        return (
            <React.Fragment>
                {{ // Mimic switch
                    listLicenses: (<LicenseList data={this.props.data}/>),
                    addLicense: (<LicenseAdd/>)
                }[this.props.type]}
            </React.Fragment>
        )
    }
}

export default GeneratedLicenseManagement